module.exports = __webpack_public_path__ + "img/marchspitze.243e5490.jpg";